module.exports = __webpack_public_path__ + "img/qrcode.64ab5c9f.jpg";